import store from "../Redux/store";

export const getTranslate = () => {

    let states = store.getState();
    return states.Apps.translate;
}